import CustomElement from '~utilities/custom-element';

const HAS_CONTRAST = 'has--contrast';
const IS_ACTIVE = 'is--active';
const JS_CONTRAST = 'js-contrast';

class ContrastButton extends CustomElement {
    constructor() {
        super();

        const contrast = localStorage.getItem(JS_CONTRAST);
        if(contrast) this.toggleContrast('add');

    }

    callback() {
        super.callback();

        this.label = this.element.querySelector('[js-contrast-button-label]');
        this.labelActive = this.label.innerText;
        this.labelDisable = this.label.getAttribute('js-contrast-button-label');
        
        this.bindEvents();
    }

    bindEvents() {
        this.element.addEventListener('click', () => {
            this.toggleContrast('toggle');

            const active = this.element.classList.contains('is--active');
            if(active) {
                this.label.innerText = this.labelDisable;
                localStorage.setItem(JS_CONTRAST, 'true');
            } else {
                this.label.innerText = this.labelActive;
                localStorage.removeItem(JS_CONTRAST);
            }
        });
    }

    toggleContrast(type) {
        document.documentElement.classList[type](HAS_CONTRAST);
        this.firstElementChild.classList[type](IS_ACTIVE);
    }
}

export default ContrastButton;
